var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animate-spinner ease-linear rounded-full border border-gray-300 border-t-blue-500",class:[_vm.sizeClasses[_vm.size]],attrs:{"id":_vm.id,"data-test-id":_vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }